import { AC, Automatic, Kitchen, Petrol, Radio, TV, Water } from 'assets';

import { GiGasStove, GiThermometerCold } from 'react-icons/gi';
import { MdOutlineBathroom, MdOutlineMicrowave } from 'react-icons/md';

export const EquipmentIcons = {
  automatic: Automatic,
  tv: TV,
  ac: AC,
  petrol: Petrol,
  kitchen: Kitchen,
  radio: Radio,
  refrigerator: GiThermometerCold,
  microwave: MdOutlineMicrowave,
  gas: GiGasStove,
  water: Water,
  bathroom: MdOutlineBathroom,
};
